export const workflowRoutes = {
    product_transfer: '/sales-warehouse/transfer-notes/new',
    customer_debt_payment: '/customers/$customerId',
    customer_debt_adjustment: '/customers/$customerId',
    customer_refund: '/customers/$customerId',
    carrier_dispatch: '/orders/$orderId',
    order_edit: '/orders/$orderId',
    order_stock_out: '/orders/$orderId',
    // M-145: popup "Nối sản phẩm" cho dòng đơn KiotViet chưa nối.
    kiotviet_item_link: '/orders/$orderId',
    order_return: '/orders/$orderId',
    delivery_assign: '/orders/$orderId',
    delivery_order_action: '/delivery-trips/$id',
    contract_delivery_trip_action: '/delivery-trips/$id',
    einvoice_push: '/orders/$orderId',
    einvoice_refresh: '/orders/$orderId',
    einvoice_manual_issue: '/orders/$orderId',
    einvoice_skip: '/orders/$orderId',
    einvoice_reopen: '/orders/$orderId',
    // M-170: lưu popup "Sửa thông tin hóa đơn" (sửa/xóa dòng trên nháp).
    einvoice_draft_edit: '/orders/$orderId',
    pos_einvoice_draft: '/sale/',
    pos_einvoice_push: '/sale/',
    expense_sync_confirm: '/accounting/expense-sync',
    expense_sync_ignore: '/accounting/expense-sync',
    snapshot_sorting: '/sorting-warehouse/stats',
    snapshot_scenting: '/scenting-warehouse/stats',
    snapshot_packaging: '/packaging-warehouse/stats',
    snapshot_product: '/warehouse-sales/stats',
    snapshot_agri_materials: '/agricultural-materials/stats',
    tea_purchase_approve: '/tea-purchases',
    tea_purchase_ballot_return: '/tea-purchases',
    // M-148: xoá phiếu cân tươi, kể cả phiếu đã gộp phiếu khô.
    tea_purchase_delete: '/tea-purchases',
    sorting_withdrawal: '/sorting-warehouse/withdrawal-notes/new',
    scenting_withdrawal: '/scenting-warehouse/withdrawal-notes/new',
    packaging_withdrawal: '/packaging-warehouse/withdrawal-notes/new',
    balance_ignore: '/accounting/reconciliation',
    expense_delete: '/accounting/expenses',
    stocktake_create: '/stocktake/new',
    stocktake_count: '/stocktake/$id',
    stocktake_submit: '/stocktake/$id',
    stocktake_approve: '/stocktake/$id',
    stocktake_cancel: '/stocktake/$id',
    sorting_stock_in: '/sorting-warehouse/stock-in-notes/new',
    sorting_stock_out: '/sorting-warehouse/stock-out-notes/new',
    scenting_stock_in: '/scenting-warehouse/stock-in-notes/new',
    scenting_stock_out: '/scenting-warehouse/stock-out-notes/new',
    packaging_stock_in: '/packaging-warehouse/stock-in-notes/new',
    packaging_stock_out: '/packaging-warehouse/stock-out-notes/new',
    agricultural_stock_in: '/agricultural-materials/stock-in-notes/new',
    agricultural_stock_out: '/agricultural-materials/stock-out-notes/new',

    pos_quick_checkout: '/sale/',
    pos_delivery_checkout: '/sale/',
    pos_checkout: '/sale/',
    stock_in_create: '/sales-warehouse/stock-in-notes/new',
    stock_out_create: '/sales-warehouse/stock-out-notes/new',
    delivery_start: '/orders/$id',
    delivery_end: 'unknown',
    balance_assign: '/accounting/reconciliation',
    expense_create: '/accounting/expenses',
    expense_update: '/accounting/expenses',
    tea_purchase_create: '/tea-purchases',
    tea_purchase_update: '/tea-purchases',
    dried_tea_purchase_create: '/dried-tea-purchases',
    dried_tea_purchase_update: '/dried-tea-purchases',
    dried_tea_purchase_bulk_create: '/dried-tea-purchases',
    dried_tea_purchase_ballot_return: '/dried-tea-purchases',
    stocktake: '/stocktake/new',
    sorting: '/sorting-warehouse/stock-in-notes/new',
    scenting: '/scenting-warehouse/stock-in-notes/new',
    packaging: '/packaging-warehouse/stock-in-notes/new',
    grower_payment: '/accounting/grower-payments',
    driver_remittance: '/driver/cash',
    contract_delivery: '/contract-deliveries/new',
    weighing: '/agriculture/weighings',
    care_log: '/agriculture/care-logs/new',
    agricultural_material: '/agricultural-materials',
    order_payment_record: '/orders/$orderId',
    // Shared by the driver dashboard, trip list and order detail; the surface
    // is the `entry_point` dimension.
    delivery_settlement: 'unknown',
} as const
export type WorkflowType = keyof typeof workflowRoutes
export const workflowActions = [
    'validation_failed',
    'warning_shown',
    'warning_confirmed',
    'item_added',
    'item_removed',
    'selection_changed',
    'product_selected',
    'lot_selected',
    'mode_changed',
    'review_opened',
    'engaged',
    'submit',
    'api_error',
] as const
export type WorkflowAction = (typeof workflowActions)[number]
export const workflowGroups = [
    'details',
    'items',
    'payment',
    'selection',
    'review',
] as const
export type WorkflowGroup = (typeof workflowGroups)[number]
export type WorkflowOutcome = 'api_confirmed' | 'closed' | 'navigated_away'
export const workflowOperations = [
    'create',
    'update',
    'confirm',
    'reject',
    'void',
    'cancel',
    'assign',
    'pickup',
    'start',
    'complete',
    'fail',
    'submit',
    'approve',
    'delete',
    'ignore',
] as const
export type WorkflowOperation = (typeof workflowOperations)[number]

export function workflowRoute(
    type: WorkflowType,
    operation?: WorkflowOperation,
): string {
    if (type === 'driver_remittance' && operation && operation !== 'create')
        return '/accounting/remittances'
    if (type === 'contract_delivery' && operation && operation !== 'create')
        return '/contract-deliveries/$id'
    if (type === 'care_log' && operation === 'delete')
        return '/agriculture/care-logs'
    if (type === 'product_transfer' && operation === 'delete')
        return '/sales-warehouse/transfer-notes/$id'
    const route = workflowRoutes[type]
    if (
        operation &&
        ['approve', 'reject', 'cancel'].includes(operation) &&
        route.endsWith('/new')
    )
        return route.replace('/new', '/$id')
    return operation === 'update' && route.endsWith('/new')
        ? route.replace('/new', '/$id/edit')
        : route
}
